<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка тортов и пирожных</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">

        </div>
      </div>
    </section>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <h2 style="margin-top:2%;">Предстоит торжество и нужно заказать торт</h2>
            <p>Посмотрите огромную галерею тортов, выбирайте дату и время и Вам привезут торт домой или в ресторан.</p>
            <p>День рождения, свадьба, юбилей генерального директора или компании – на сайте <router-link to="/">хочу-поесть.рф</router-link> найдутся лучшие решения на все случаи жизни. У Вашего ребенка день рождения – закажите оригинальный торт с любимыми мультяшными героями Ваших детей.</p>
            <p>Выбирайте торт из множества вариантов по размеру и весу.</p>
            <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/cake1.jpg" alt="Доставка тортов и пирожных" width="700" /></center></p>
            <h2 style="margin-top:2%;">Просто захотелось сладенького</h2>
            <p>К Вам неожиданно пришли гости? Не бежать же в магазин! Проще и быстрее сделать заказ торта, пирожных и других кондитерских изделий всего за 2 минуты на сайте. Не успеете оглянуться и торт Вам привезут прямо домой. А пока поставьте чайник.</p>
            <p>Отмечаете день рождения в офисе? Закажите торты, печенье, пирожные и их доставят в точно в назначенное время,  чтобы Вы смогли и удивить и порадовать коллег одновременно.</p>
            <p>Все чаще и чаще жители городе заказывают кондитерские изделия с доставкой домой или в офис. Потому что заказ с доставкой это зачастую дешевле, чем покупать в самой кондитерской. И не забывайте о том, что у нас реальный cash-back, который Вы получаете от каждого заказа!</p>
            <p>А Вы уже знаете, как есть практически бесплатно?</p>
            <div class="bottom_knopka"><a href="#" class="knopka_2"> ПРОГРАММА ЛОЯЛЬНОСТИ</a></div>
            <p style="margin-top:2%;">А если у Вас есть время и желание порадовать себя и своих родных и друзей – посмотрите рецепты тортов, которыми с нами поделились самые вкусные кондитерские города {{city.name}}.</p>
            <router-link :to="'/product/15'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'cake',
  props: ['city']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/cake.vue